import { useEffect, useRef } from 'react'
import { useLazyReorganizeStatusQuery } from '../../group_leader/store/glApi'
import {
  REORGANIZE_OUTCOME,
  REORGANIZE_POLL_INTERVAL_MS,
  REORGANIZE_POLL_MAX_ATTEMPTS,
} from '../helpers/pairings'

// Polls a relayed job until it ends; resolves { outcome, data }, CANCELLED once the step unmounts.
const useJobPoll = ({ leagueId, roundId }) => {
  const [ triggerStatus ] = useLazyReorganizeStatusQuery()
  const timerRef = useRef(null)
  const mountedRef = useRef(true)

  useEffect(() => () => {
    mountedRef.current = false
    if (timerRef.current) { clearTimeout(timerRef.current) }
  }, [])

  return (jobId) => new Promise((resolve) => {
    let attempts = 0
    const tick = async () => {
      if (!mountedRef.current) { resolve({ outcome: REORGANIZE_OUTCOME.CANCELLED }); return }
      attempts += 1
      if (attempts > REORGANIZE_POLL_MAX_ATTEMPTS) { resolve({ outcome: REORGANIZE_OUTCOME.FAILED }); return }
      const { data, error } = await triggerStatus({ leagueId, roundId, jobId })
      // Re-checked after the await: a reply during unmount must not set state.
      if (!mountedRef.current) { resolve({ outcome: REORGANIZE_OUTCOME.CANCELLED }); return }
      if (error || data?.status === 'errors') { resolve({ outcome: REORGANIZE_OUTCOME.FAILED, data }); return }
      if (data?.completed) { resolve({ outcome: REORGANIZE_OUTCOME.COMPLETED, data }); return }
      timerRef.current = setTimeout(tick, REORGANIZE_POLL_INTERVAL_MS)
    }
    tick()
  })
}

export default useJobPoll
